import Api from '../api/api.js';

import Modal from '../alerts/modal.js';


export default class LornaLesson {


	constructor(lesson_id)
	{
		this.lesson_id = lesson_id;
	}


	updateProgress(data={})
	{
		(new Api).putRequest(`/lessons/${this.lesson_id}/progress`, data)

	   	   .then((response) => {

				if (response.hasOwnProperty('finished') && response.finished) {

					this.finished();
				
				}
			
			});
	}


	forceFinish()
	{
		(new Api).postRequest(`/lessons/${this.lesson_id}/finish`, {})

	   	   .then((response) => {
	   		
	   			this.finished();
	   		
	   		});
	}


	finished()
	{
		this.getFinishedModal()
			
			.then((response) => {

		  		this.showFinishedModal(response);
			
			})
			.then(() => {
				
				this.setSwalHandlers();
			
			});

		this.renderFooter();
	}


	markAsViewed()
	{
		return this.forceFinish();
	}


	toggleFavorited(current_status = 1) 
	{
		const data = { 
			
			favorited: current_status ? 0 : 1
		
		};

		const msg = data.favorited == 1 ? 'Lesson added to favorites - You can use the Search Page to filter by Favourites' : 'Lesson removed from favorites';
		
		(new Api).putRequest(`/lessons/${this.lesson_id}`, data)

		   .then((response) => {
			
				(new Modal).success('Success', msg, 'Ok');
				
				this.renderFooter();
			
			});
	}


	getFinishedModal() 
	{
		return new Promise((resolve, reject) => {
		
			(new Api).getRequest(`/lessons/${this.lesson_id}/finished`)
		   	 		 
		   	 		 .then((response) => {
						
						resolve(response);
					
					});
		});
	}


	setSwalHandlers() 
	{
		$('.swal-button--cancel').on('click', function() {
		
			Swal.close();
		
		});
	}


	showFinishedModal(response)
	{
		var content = document.createElement("span");
		
		content.innerHTML = response.html;
		
		return Swal.fire({
			title:'End of Lesson',
			icon:'success', 
			html:content,
	      focusConfirm: false,
	      showCancelButton: false,
	      showConfirmButton: false,customClass: {
			  htmlContainer: 'd-flex',
			}
	    })
	}


	getFooter()
	{
		return new Promise((resolve, reject) => {
			
			(new Api).getRequest(`/lessons/${this.lesson_id}/footer`)
		   	   
		   	   .then((response) => {
				
					resolve(response);
				
				});
		});
	}


	renderFooter()
	{
		this.getFooter().then((response) => {
			
			$('.actions-ajax').html(response.html);
		
		});
	}


}